import { Component, ContentChild, ElementRef, EventEmitter, Host, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseCard } from '@lx/shared/ui/directives';
import { CommonModule } from '@angular/common';
import { observeMutation } from '@lx/shared/utils';
import { OfferLabelComponent } from '../offer-label/offer-label.component';

@Component({
  standalone: true,
  selector: 'lx-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss'],
  imports: [CommonModule, OfferLabelComponent],
})
export class SummaryCardComponent extends BaseCard<unknown> implements OnInit, OnDestroy {
  @Input() mode: 'cover' | 'back' = 'cover';
  @Input() hasPromotion = false;
  @Input() containerElement: HTMLElement;
  @Output() showOfferPopup = new EventEmitter<unknown>();
  @ContentChild('cardCoverTpl') cardCoverTpl: TemplateRef<unknown>;
  @ContentChild('cardBackTpl') cardBackTpl: TemplateRef<unknown>;
  public imageHeight = 0;
  private subscription = new Subscription();

  constructor(@Host() private el: ElementRef) {
    super();
  }

  public ngOnInit(): void {
    const el: HTMLElement = this.containerElement ?? this.el.nativeElement.parentElement;
    const mo = observeMutation(el, { subtree: true, childList: true });
    this.subscription.add(
      mo.subscribe(() => {
        this.imageHeight = el.offsetHeight;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  showPromotionPopup(item: unknown) {
    this.showOfferPopup.emit(item);
  }
}
